window.pdpFooterInit = function() {
  var overlay = document.getElementById('pdp-modal-overlay');
  var triggers = document.querySelectorAll('[data-modal]');
  var closes = document.querySelectorAll('[data-modal-close]');

  if (!overlay || !triggers.length) return;

  // Guard against double-init (theme editor re-renders the section)
  if (overlay.dataset.pdpPortaled === '1') return;
  overlay.dataset.pdpPortaled = '1';

  // Move overlay + modals to <body> so they escape any transformed/
  // positioned ancestor that traps them in a lower stacking context.
  // This is the actual fix — not z-index.
  document.body.appendChild(overlay);
  document.querySelectorAll('.pdp-modal').forEach(function(m) {
    document.body.appendChild(m);
  });

  function openModal(id) {
    document.getElementById('modal-' + id).classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeAll() {
    document.querySelectorAll('.pdp-modal').forEach(function(m) { m.classList.remove('is-open'); });
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  triggers.forEach(function(t) {
    t.addEventListener('click', function(e) {
      e.preventDefault();
      openModal(t.dataset.modal);
    });
  });

  closes.forEach(function(c) { c.addEventListener('click', closeAll); });
  overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeAll(); });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.pdpFooterInit);
} else {
  window.pdpFooterInit();
}